import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH, MOTOR_CADASTRO_RECOMPRA_PROGRAMADA_PROJECAO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorRecompraProgramadaService {
    constructor() {
        this.request = new ServiceRequest()
    }

    // Temporario
    async getTemporarioRecompraProgramada(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/recompra-programada`
        return this.request.get(path)
    }

    async createCadastroTemporarioRecompraProgramada(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/recompra-programada`
        return this.request.post(path, payload)
    }

    async deleteCadastroTemporarioRecompraProgramada(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/recompra-programada`
        return this.request.delete(path)
    }

    // Producao
    async getRecompraProgramada(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/recompra-programada`
        return this.request.get(path)
    }

    async createCadastroRecompraProgramada(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/recompra-programada`
        return this.request.post(path, payload)
    }

    async updateCadastroRecompraProgramada(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/recompra-programada`
        return this.request.put(path, payload)
    }

    async deleteCadastroRecompraProgramada(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/recompra-programada`
        return this.request.delete(path)
    }

    async geraProjecaoRecompraProgramada(payload) {
        return this.request.post(`${MOTOR_CADASTRO_RECOMPRA_PROGRAMADA_PROJECAO_PATH}`, payload)
    }

}

export default MotorRecompraProgramadaService